"use client";

import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "The uPVC roofline replacement in Newcastle was flawless. Five Star Roofline really lives up to the name. Our house looks brand new.",
  name: "David M.",
  role: "Newcastle Homeowner",
  rating: 5
}, {
  quote: "Professional service from start to finish. The dry verge installation was tidy and efficient. Best roofing contractors in the North East.",
  name: "Sarah L.",
  role: "Durham Resident",
  rating: 5
}, {
  quote: "We had our flat roof replaced with EPDM rubber. The team was punctual and the gold-standard finish is exactly what we wanted.",
  name: "Mark T.",
  role: "Sunderland Property Owner",
  rating: 5
}, {
  quote: "Reliability and high-quality workmanship. They handled our dry ridge system perfectly. Highly recommend their services for any roofline needs.",
  name: "Jennifer K.",
  role: "Middlesbrough Client",
  rating: 5
}];
export default function ClientReflections() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19663" id="trusted-by-our-customers" ref={ref} className={cn("dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-1000 ease-out")}>
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none opacity-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_70%)] blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-primary font-sans uppercase tracking-widest text-sm md:text-base font-bold mb-4">
            Five Star Reputation
          </h2>
          <h3 className="text-4xl md:text-6xl font-serif text-white tracking-tight">
            Trusted by Our Customers
          </h3>
        </div>

        <div className="max-w-4xl mx-auto">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center text-center px-6 md:px-16 py-12 bg-secondary/40 backdrop-blur-md border border-white/10 rounded-3xl shadow-2xl mx-2">
                    {}
                    <div className="mb-8 text-primary/30">
                      <Quote className="w-10 h-10 md:w-14 md:h-14 rotate-180 fill-current" />
                    </div>

                    {}
                    <blockquote className="mb-10">
                      <p className="font-serif italic text-2xl md:text-4xl lg:text-4xl leading-relaxed text-white">
                        &ldquo;{testimonial.quote}&rdquo;
                      </p>
                    </blockquote>

                    {}
                    <div className="flex gap-1.5 mb-8">
                      {Array.from({
                    length: testimonial.rating
                  }).map((_, starIndex) => <Star key={starIndex} className="w-5 h-5 fill-primary text-primary drop-shadow-[0_0_8px_rgba(234,179,8,0.6)]" />)}
                    </div>

                    {}
                    <div className="space-y-2">
                      <cite className="block font-serif text-primary text-xl md:text-2xl font-bold not-italic">
                        {testimonial.name}
                      </cite>
                      <span className="block text-muted-foreground text-xs md:text-sm font-sans tracking-widest uppercase">
                        {testimonial.role}
                      </span>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            {}
            <div className="hidden md:block">
              <CarouselPrevious className="border-primary/30 text-primary hover:bg-primary/20 hover:text-primary hover:border-primary -left-12 lg:-left-24 h-12 w-12" />
              <CarouselNext className="border-primary/30 text-primary hover:bg-primary/20 hover:text-primary hover:border-primary -right-12 lg:-right-24 h-12 w-12" />
            </div>
            
            {}
            <div className="flex md:hidden justify-center gap-6 mt-10">
               <CarouselPrevious className="static translate-y-0 border-primary/30 text-primary hover:bg-primary/20 hover:text-primary hover:border-primary h-12 w-12" />
               <CarouselNext className="static translate-y-0 border-primary/30 text-primary hover:bg-primary/20 hover:text-primary hover:border-primary h-12 w-12" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}